<template>
  <div>
<!--    <pageTop></pageTop>-->

    <div ref="banner" class="banner content-item-block">
      <div class="video-wrapper">


        <video
            class="video"
            preload="auto"
            muted
            loop
            playsinline
            autoplay
            src="//juanxiuhe.oss-cn-beijing.aliyuncs.com/dibao/home.mp4"
            tabindex="-1">
          <source src="//juanxiuhe.oss-cn-beijing.aliyuncs.com/dibao/home.mp4" type="video/mp4">
        </video>

      </div>
      <h1 class="banner-title">

        <p   class="text_mobile">专注直播，奔赴热爱</p>

        <div class="subTitle-mobile" >JOIN EAST·DB</div>
      </h1>
      <div class="search">
        <img  @click="searchJobs" src="@/assets/images/toudi.png" >
      </div>
      <div class="arrow-down" @click="scrollDown()"></div>
      <div style="margin-top: 2px" class="arrow-down" @click="scrollDown()"></div>

    </div>
    <div class="row">
      <div class="col-md-1">
<!--        <img src="@/assets/images/bg1.png">-->
      </div>
    <!-- 产品 -->
    <section class="col-md-10 w3l-bottom-grids-6 py-5 " style="margin-top: -90px" id="bottom" >
      <div>
        <div  class="top_menu_04" style="font-size: 25px;  font-family: 'Microsoft YaHei', Arial, sans-serif;">
          We get live streams, we get you better.
        </div>

        <div class="top_menu_05" style="margin-top: 20px;margin-bottom: 100px;  text-align: left;">
          懂直播，更懂你
        </div>

        <div class="top_menu_05" style="margin-top: -60px;margin-bottom: 100px;  text-align: left;">
          关于东方地保
        </div>

      </div>



    </section>

      <div class="col-md-1">
<!--        <img src="@/assets/images/bg2.png">-->
      </div>
  </div>

    <div class="row"  >
<!--      <div class="col-md-1">-->
<!--        &lt;!&ndash;        <img src="@/assets/images/bg2.png">&ndash;&gt;-->
<!--      </div>-->

      <div class="col-md-12" style="padding-left: 30px;margin-top: -150px">

<!--        <div  class="el-collapse-item__header mobile_box-shadow" style="height: 80px;padding: 12px">-->
<!--            <span style="padding-left: 10px">-->
<!--           关于东方地保-->
<!--          </span>-->


<!--          <i  class="el-collapse-item__arrow el-icon-arrow-right"></i>-->
<!--        </div>-->



        <el-collapse  class="mobile_box-shadow"  v-model="activeNames" @change="handleChange">
          <el-collapse-item>
            <template #title>
              <div class="custom-title">
                {{ customTitle }}
              </div>
            </template>
            <div style="margin: 20px;">
              <!--              <p class="home_p">泛娱乐直播领域,并以卓越的成绩崭露头角。在该领域的首次尝试中,我们一举荣膺多个官方平台奖项,并在 2020 年第一季度成功实现营收突破千万元。 </p>-->
              <p class="home_p">经过近两年的深耕细作和经验积累，我们于2021年对基地进行整体迁移，迁移至年轻人的潮流中心集美区万科云城,并深化多元化布局战略,业务除主营的泛娱乐直播运营外,还包含 MCN、本地生活团购、本地生活服务、社区电商、物流业务、健身房业务等,拥有独立的办公楼近 10000平方米，致力于为客户提供完善的配套设施和出
                色运营能力。</p>
              <p class="home_p">
                通过不断的沉淀与发展,我们不仅与抖音、快手、微信视频号等平台达成了长期战略合作,还吸纳了来自全国各地(含港、澳、台)的近万名主播,包括金牌主播、超级大V和全国现象级红人,拥有全网2亿粉丝总量的庞大社群，一跃成为厦门甚至福建省规模最大的互联网直播基地之一。
              </p>
              <p class="home_p">
                我们深信,我们的创新和专业知识,以及优质的客户服务,将帮助我们在未来取得更大的成功,并为广大用户带来更加丰富多彩的直播体验。
              </p>
            </div>

          </el-collapse-item>
        </el-collapse>




      </div>
<!--      <div class="col-md-1">-->
<!--        &lt;!&ndash;        <img src="@/assets/images/bg2.png">&ndash;&gt;-->
<!--      </div>-->
    </div>
    <div class="row"  style="margin-top: -20px">

    <div   style="margin: 30px">
    <el-tabs v-model="activeName"  @tab-click="handleClick">
      <el-tab-pane label="职位"  name="first">

        <div  class="el-collapse-item__header mobile_box-shadow" >
          <a ><img src="@/assets/mobileImages/50.png" width="85px"></a>

          <span class="different-fonts">
            <span class="first-line">直播运营</span><br>
            <span class="second-line">致力于为主播及素人主播提供专业的基础运营和精细化运营服务。</span>
          </span>
          <i  class="el-collapse-item__arrow el-icon-arrow-right"></i>
        </div>





        <div  class="el-collapse-item__header mobile_box-shadow" >
          <a ><img src="@/assets/mobileImages/51.png" width="55px"></a>
          <span class="different-fonts">
            <span class="first-line">本地生活运营</span><br>
            <span class="second-line"></span>
          </span>
<!--          <span style="padding-left: 10px;margin-top: -30px">-->
<!--           本地生活运营-->
<!--          </span><br/>-->
<!--          <span class="word">-->
<!--           -->
<!--          </span>-->
          <i  class="el-collapse-item__arrow el-icon-arrow-right"></i>
        </div>

        <div  class="el-collapse-item__header mobile_box-shadow" >
          <a ><img src="@/assets/mobileImages/52.png" width="55px"></a>
          <span class="different-fonts">
            <span class="first-line">电商运营</span><br>
            <span class="second-line"></span>
          </span>

          <i  class="el-collapse-item__arrow el-icon-arrow-right"></i>
        </div>



        <div  class="el-collapse-item__header mobile_box-shadow" >
          <a ><img src="@/assets/mobileImages/53.png" width="85px"></a>

          <span class="different-fonts">
            <span class="first-line">职能/支持</span><br>
            <span class="second-line">成为业务合作伙伴为东方地保的前行提供强有力的支持和赋能。</span>
          </span>

          <i  class="el-collapse-item__arrow el-icon-arrow-right"></i>
        </div>

        <div  class="el-collapse-item__header mobile_box-shadow" >
          <a ><img src="@/assets/mobileImages/54.png" width="55px"></a>
          <span class="different-fonts">
            <span class="first-line">市场</span><br>
            <span class="second-line"></span>
          </span>

          <i  class="el-collapse-item__arrow el-icon-arrow-right"></i>
        </div>

        <div  class="el-collapse-item__header mobile_box-shadow" >
          <a ><img src="@/assets/mobileImages/55.png" width="55px"></a>
          <span class="different-fonts">
            <span class="first-line">销售</span><br>
            <span class="second-line"></span>
          </span>

          <i  class="el-collapse-item__arrow el-icon-arrow-right"></i>
        </div>
        <div  class="el-collapse-item__header mobile_box-shadow" >
          <a ><img src="@/assets/mobileImages/56.png" width="55px"></a>

          <span class="different-fonts">
            <span class="first-line">技术</span><br>
            <span class="second-line"></span>
          </span>

          <i  class="el-collapse-item__arrow el-icon-arrow-right"></i>
        </div>

        <div  class="el-collapse-item__header mobile_box-shadow" >
          <a ><img src="@/assets/mobileImages/57.png" width="55px"></a>

          <span class="different-fonts">
            <span class="first-line">更多职位</span><br>
            <span class="second-line"></span>
          </span>

          <i  class="el-collapse-item__arrow el-icon-arrow-right"></i>
        </div>

      </el-tab-pane>
      <el-tab-pane label="业务与服务" name="second">


        <div  class="el-collapse-item__header mobile_box-shadow" style="height: 80px;padding: 12px">
          <a ><img src="@/assets/mobileImages/42.png" width="55px"></a>

          <span class="different-fonts">
            <span class="first-line">地保直播</span><br>
            <span class="second-line"></span>
          </span>

          <i  class="el-collapse-item__arrow el-icon-arrow-right"></i>
        </div>


        <div  class="el-collapse-item__header mobile_box-shadow" >
          <a ><img src="@/assets/mobileImages/43.png" width="55px"></a>
          <span class="different-fonts">
            <span class="first-line">地保联营</span><br>
            <span class="second-line"></span>
          </span>

          <i  class="el-collapse-item__arrow el-icon-arrow-right"></i>
        </div>

        <div  class="el-collapse-item__header mobile_box-shadow" >
          <a ><img src="@/assets/mobileImages/44.png" width="55px"></a>
          <span class="different-fonts">
            <span class="first-line">地保游戏</span><br>
            <span class="second-line"></span>
          </span>

          <i  class="el-collapse-item__arrow el-icon-arrow-right"></i>
        </div>

        <div  class="el-collapse-item__header mobile_box-shadow" >
          <a ><img src="@/assets/mobileImages/48.png" width="55px"></a>

          <span class="different-fonts">
            <span class="first-line">柠檬招聘</span><br>
            <span class="second-line"></span>
          </span>

          <i  class="el-collapse-item__arrow el-icon-arrow-right"></i>
        </div>

        <div  class="el-collapse-item__header mobile_box-shadow" >
          <a ><img src="@/assets/mobileImages/45.png" width="55px"></a>


          <span class="different-fonts">
            <span class="first-line">本地生活</span><br>
            <span class="second-line"></span>
          </span>

          <i  class="el-collapse-item__arrow el-icon-arrow-right"></i>
        </div>

        <div  class="el-collapse-item__header mobile_box-shadow" >
          <a ><img src="@/assets/mobileImages/46.png" width="55px"></a>


          <span class="different-fonts">
            <span class="first-line">社区电商</span><br>
            <span class="second-line"></span>
          </span>

          <i  class="el-collapse-item__arrow el-icon-arrow-right"></i>
        </div>

        <div  class="el-collapse-item__header mobile_box-shadow" >
          <a ><img src="@/assets/mobileImages/47.png" width="55px"></a>

          <span class="different-fonts">
            <span class="first-line">地保物流</span><br>
            <span class="second-line"></span>
          </span>

          <i  class="el-collapse-item__arrow el-icon-arrow-right"></i>
        </div>
        <div  class="el-collapse-item__header mobile_box-shadow" >
          <a ><img src="@/assets/mobileImages/49.png" width="55px"></a>

          <span class="different-fonts">
            <span class="first-line">合作咨询</span><br>
            <span class="second-line"></span>
          </span>

          <i  class="el-collapse-item__arrow el-icon-arrow-right"></i>
        </div>


      </el-tab-pane>

    </el-tabs>
  </div>

    </div>


    <Footer ></Footer>

  </div>
</template>

<script>
// @ is an alias to /src
import { watchScrollDirection } from "@/helper/utilities.js";
import Footer from "@/components/footer.vue";
import pageTop from "@/components/pageTop/pageTop";


// import home from '@/api/home'

export default {
  name: "home",
  components: {pageTop, Footer},
  data() {
    return {
      marginWidth: this.isMobile()?'10px':'55px', // 初始颜色为透明
      navWidth: this.isMobile()?'55px':'80px', // 初始颜色为透明
      productLayerVisible: true,
      search: "",
      products: [],
      jobCategories: [],
      byteStandards: [],
      byteStandardActiveIndex: 0,
      staffStories: [],
      activeName:'first',
      activeNames: ['1'],
      customTitle:"                2018年,东方地保(EAST DB)正式进军泛娱乐直播领域,并以卓越的成绩崭露头角。在该领域的首次尝试中,我们一举荣膺多个官方平台奖项,并在 2020 年第一季度成功实现营收突破千万元。\n"
    };
  },
  methods: {
    onScrollRightAnimationEnd() {
      this.productLayerVisible = false;
    },
    scrollDown() {

      window.scrollBy(0, 1000);
      // this.$refs.product.scrollIntoView({
      //   behavior: "smooth",
      //   block: "start"
      // });
    },
    searchJobs(keyword) {
      this.$router.push({ name: "jobs", params: { keyword } });
    },
    jumpToDetail(item) {
      this.$router.push({ name: "products", params: item });
    },
    handleClick(tab, event) {
      console.log(tab, event);
    },
    handleChange(val) {
      console.log(val);
    }

  },
  mounted() {
    const rootVm = this.$root;
    rootVm.$emit(
      "home-scrolling",
      { directionX: 1, directionY: -1 },
      { x: document.body.scrollLeft, y: document.body.scrollTop }
    );
    this.unwatch = watchScrollDirection(window, function(...args) {
      rootVm.$emit("home-scrolling", ...args);
    });
  },
  destroyed() {
    this.unwatch();
  }
};
</script>

<style>
/* @import "../assets/transition.css";  */
</style>

<style lang="less" scoped>
.text {
  font-weight: bold;
  line-height: 0.1; /* 设置行高为字体大小的1.5倍 */
  letter-spacing: 0.3em; /* 使用em单位，相对于字体大小设置间距 */
  font-family: 'Arial', sans-serif; /* 使用Arial字体，如果没有则使用系统默认无衬线字体 */
}
50%
.home_p{
  font-size: 13px;
  color: #59565b;
  font-weight: normal;

  //font-weight: bold;
  //font-family: "等线";
  //font-size: 16px; /* 设置基础字体大小为16像素，提升可读性 */
  //line-height: 1.6; /* 设置较为舒适的行间距，1.6是一个常见且易读的选择 */
  //color: #000000; /* 使用深灰色作为正文颜色，比纯黑更柔和 */
  //text-align: justify; /* 文本两端对齐，使段落看起来更整齐（如果需要的话，有时左对齐也是很好的选择） */
  //margin: 0 auto; /* 如果希望整体内容居中，可以设置外边距为自动，这里假设body有固定宽度或max-width */
  //max-width: 800px; /* 限制内容最大宽度，提升阅读体验，特别是在宽屏设备上 */
  //padding: 10px; /* 添加内边距，使内容与边界有一定的呼吸空间 */
}
.subTitle {
  margin-top: 10px;
}
.subTitle-mobile{
  //margin-top: -50px;
  position: relative;
  font-size: 14px;
  letter-spacing: 10px;
}
.video{
  content: "";
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 90%;
  background: linear-gradient(rgba(0, 0, 0, 0.5), rgba(0, 0, 0, 0.5));
}
.text_mobile{
  font-size: 30px;
  margin-bottom: 5px;
}
/deep/ .el-drawer__header {
  /* scoped 下需要使用 /deep/ 或 >>> 来穿透样式 */
  background-color: #FFFFFF;
  font-size: 30px;
  color: #333333;
  font-weight: bold;
}

/deep/ .el-drawer__title {
  color: #333333;
  font-size: 18px;
}

/deep/ .el-tabs__item:hover {
  color: #f4bc20;
  cursor: pointer;
}

/deep/.el-tabs__item.is-active {
  color: #f4bc20;
}
/deep/ .el-tabs__active-bar {
  position: absolute;
  bottom: 0;
  left: 0;
  height: 2px;
  color: #f4bc20;
  z-index: 1;
  transition: transform .3s cubic-bezier(.645,.045,.355,1);
  list-style: none;
}

/deep/ .el-tabs__active-bar {
  position: absolute;
  bottom: 0;
  left: 0;
  height: 2px;
  background-color: #f4bc20;
  z-index: 1;
  transition: transform .3s cubic-bezier(.645,.045,.355,1);
  list-style: none;
}
/deep/ .el-tabs__nav{
  white-space: nowrap;
  position: relative;
  transition: transform .3s;
  left: 28%;
  z-index: 2;
}
/deep/ .el-collapse-item{
  font-weight: normal;
}
/deep/ .el-collapse-item__wrap {
  will-change: height;
   background-color: rgba(255, 255, 255, 0.36);
  overflow: hidden;
  box-sizing: border-box;
  border-bottom: 1px solid #EBEEF5;
}
/deep/ .el-collapse {


  background-color: #ffffff; /* 背景颜色 */
  border: 1px solid #cccccc; /* 边框 */
  border-radius: 15px; /* 圆角半径 */
  text-align: center; /* 文本居中 */
  box-shadow: 0 4px 8px rgba(0,0,0,0.1); /* 阴影效果 */


}
/deep/ .el-collapse-item__header {
  font-size: 16px;
  //font-weight: bold;
  height: 95px;
  padding: 12px;
  max-length:300px;
  margin-top: 10px;
  border-radius: 15px; /* 所有四个角都有10px的圆角 */

  //display: -webkit-box;
  //-webkit-line-clamp: 2; /* 显示的行数 */
  //-webkit-box-orient: vertical;
  //overflow: hidden;
}

///deep/ .el-collapse-item{
//  background-color: #ffffff;
//}

/deep/ .el-tabs__item{
  text-align: center;
  font-size: 16px;
  font-family: 'Arial', sans-serif; /* 第一行的字体 */
  font-weight: bold; /* 可以设置为粗体或其他样式 */
  //line-height: 1.6;
  color: #333333;
}
.custom-title{
  font-size: 13px;
  //color: #59565b;
  line-height: 1.1; /* 设置较为舒适的行间距，1.1是一个常见且易读的选择 */
  color: #303133;
  text-align: justify; /* 文本两端对齐，使段落看起来更整齐（如果需要的话，有时左对齐也是很好的选择） */
  margin: 0 auto; /* 如果希望整体内容居中，可以设置外边距为自动，这里假设body有固定宽度或max-width */
  max-width: 800px; /* 限制内容最大宽度，提升阅读体验，特别是在宽屏设备上 */
  padding: 10px; /* 添加内边距，使内容与边界有一定的呼吸空间 */
  font-weight: normal;

}
.word {
  margin-left: -62px;
  font-size: 12px;
  margin-top: 10px;
}
.different-fonts {
  font-size: 16px; /* 设置基础字体大小 */
  margin-top: 20px; /* 上边距 */
  margin-bottom: 20px; /* 下边距 */
  margin-left: 20px; /* 左边距 */
  line-height: 1.1; /* 减少行间距 */
}
.different-fonts .first-line {
  font-family: 'Arial', sans-serif; /* 第一行的字体 */
  font-weight: bold; /* 可以设置为粗体或其他样式 */
}
.different-fonts .second-line {
  font-size: 13px;
  color: #59565b;

  //font-family: 'Times New Roman', serif; /* 第二行的字体 */

  //font-style: italic; /* 可以设置为斜体或其他样式 */
}
</style>
